import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from "react-router-dom";

export default function RouteErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();

  let title = "Unexpected error";
  let message = "Something went wrong while handling this page.";

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`;
    try {
      const data = error.data;
      message = (data && data.message) || message;
    } catch {
      // ignore
    }
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="max-w-xl w-full rounded-2xl shadow p-6">
        <h1 className="text-2xl font-semibold">{title}</h1>
        <p className="mt-2 opacity-80">{message}</p>

        {process.env.NODE_ENV === "development" &&
          !isRouteErrorResponse(error) && (
            <pre className="mt-4 p-3 rounded bg-black/5 overflow-auto text-xs">
              {String(error?.stack || error)}
            </pre>
          )}

        <div className="mt-4 flex gap-2">
          <button
            onClick={() => navigate(0)}
            className="px-4 py-2 rounded-xl border"
          >
            Retry
          </button>
          <button
            onClick={() => navigate("/")}
            className="px-4 py-2 rounded-xl border"
          >
            Go home
          </button>
        </div>
      </div>
    </div>
  );
}
